import React from 'react'

export default function scrollList({ children, className, horizontalStyle=false, ...props }) {

    const horizontal = horizontalStyle && 'scrollList_horizontal ' || ''

    const cName = "scrollList " + horizontal + className || ''

    return (
        // <div {...props} className={'scrollList ' + className || ''}>
        <>
            {/* <div className="scrollList-topShadow"></div> */}
            <div className={cName}>
                {children}
            </div>
            {/* <div className="scrollList-bottomShadow"></div> */}
        </>

        // </div>
    )
}
